const colors = {
	NOTIFICATION			 : '#F0CEC4',
	BRAND_BLUE_DARK    : '#17304D',
	BRAND_GREEN        : '#94c249',
	BRAND_ORANGE       : '#fcb533',
	BRAND_RED_DARK     : '#710923',
	BRAND_RED          : '#FF3334',
	BRAND_PINK         : '#FB666A',
	WHITEEST           : '#FDAFAF',
	BRAND_CONFIDENTIAL : '#e1e6f1',
	GRAY_LIGHT         : '#D8D8D8',
	GRAY_LIGHTER       : '#E9E5E2',
	GRAY               : '#9B9B9B',
	GRAY_MIDDLE        : '#4A4A4A',
	GRAY_DARK          : '#333333',
	GRAY_DARKER        : '#2D2D2B',
	TRANSPARENT        : 'transparent',
	WHITE              : '#ffffff',
	BLACK              : '#000000'
};

//#[0-9a-f]{3,6}
export default colors;


// WEBPACK FOOTER //
// ./src/utils/colors.js